<template>
  <div>
    <BForm @submit.prevent>
      <BCard>
        <BRow class="">
          <BCol class="d-flex justify-content-between align-items-center">
            <h2>Series</h2>
          </BCol>
        </BRow>
        <ValidationObserver ref="serieForm">
          <BForm>
            <BRow class="align-items-center d-flex justify-content-between">
                <div class="d-flex col col-10 ">
                  <TextInputValidated vsName="Nombre" vsMd="3" :vsModel.sync="serie.name" vsRequired vsRules="required" />
                  <TextInputValidated vsName="Serie" vsMd="3" :vsModel.sync="serie.identifier" vsRequired vsRules="required" />
                  <VSelectValidated vsMd="3" vsName="Actividad económica" :vsModel.sync="serie.economic_activity_id" :vsReduce="activity => activity.id" :vsOptions="economicActivities" vsLabel="name" vsRequired vsRules="required"/>
                  <VSelectValidated vsMd="3" vsName="Tipo de documento" :vsModel.sync="serie.billing_document_id" :vsReduce="doc => doc.id" :vsOptions="billingDocuments" vsLabel="name" vsRequired vsRules="required"/>
                </div>
                <BCol cols="2" class="text-right">
                  <BButton variant="primary" @click="createSerie">Añadir</BButton>
                </BCol>
            </BRow>
          </BForm>
        </ValidationObserver>
        <div >
          <BCardActions
          v-for="b in billingDocuments"
            :title="b.name"
            action-collapse
            collapsed
            >
            <BCardText >
              <BTable class="mt-2" :items="b.series" :fields="seriesCols" ref="documentsTable" >
                <template #cell(name)="data" >
                  <TextInputValidated :key="documentsTable+data.item.name " v-if="data.item.modify" :vsModel.sync="data.item.name" class="p-0 m-0"></TextInputValidated>
                  <span :key="documentsTable+data.item.name +'2'" v-else> {{ data.item.name }} </span>
                </template>
                <template #cell(identifier)="data" >
                  <span> {{ data.item.identifier }} </span>
                </template>
                <template #cell(sequence)="data" >
                  <span> {{ data.item.sequence }} </span>
                </template>
                <template #cell(economic_activity)="data" >
                  <VSelectValidated v-if="data.item.modify" vsName="" :vsModel.sync="data.item.economic_activity_id" :vsReduce="activity => activity.id" :vsOptions="economicActivities" vsLabel="name" vsRequired vsRules="required"/>

                  <span  v-else> {{ data.item.economic_activity.name }} </span>
                </template>
                <template #cell(actions)="data">
                  <BDropdown v-if="!data.item.modify" variant="link" no-caret :right="$store.state.appConfig.isRTL" >
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                    </template>
                    <BDropdownItem @click="data.item.modify=true; documentsTable++">
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">{{ $t('Edit') }}</span>
                    </BDropdownItem>
                    <BDropdownItem @click="deletePopupAxios(data.item.id, `series/${data.item.id}`)">
                      <feather-icon icon="TrashIcon" />
                      <span class="align-middle ml-50">{{ $t('Delete') }}</span>
                    </BDropdownItem>
                  </BDropdown>
                  <div v-else class="d-flex">
                    <BButton variant="flat-success" class="btn-icon" @click="editSerie(data.item)">
                      <FeatherIcon size="18" icon="CheckIcon" />
                    </BButton>
                    <BButton variant="flat-danger" class="btn-icon" @click="data.item.modify=false; documentsTable++">
                      <FeatherIcon size="18" icon="XIcon" />
                    </BButton>
                  </div>

                </template>
              </BTable>
            </BCardText>
          </BCardActions>

        </div>
      </BCard>

      <BCard>
        <BRow class="mb-2">
          <BCol class="d-flex justify-content-between align-items-center">
            <h2>Actividad económica</h2>
          </BCol>
        </BRow>
      
        <ValidationObserver ref="activityForm">
          <BForm>
            <BRow class="align-items-center d-flex justify-content-between">
              <div class="col col-10 d-flex">
                <TextInputValidated vsName="Nombre" vsMd="3" :vsModel.sync="economic_activity.name" vsRequired vsRules="required" />
                <NumberInputValidated vsName="Sección" vsMd="3" :vsModel.sync="economic_activity.section" vsRequired vsRules="required" />
                <TextInputValidated vsName="Epígrafe" vsMd="3" :vsModel.sync="economic_activity.epigraph" vsRequired vsRules="required" />
                
              </div>
              <BCol cols="2" class="text-right">
                <BButton  variant="primary" @click="createEconomicActivity">Añadir</BButton>
              </BCol>
            </BRow>
          </BForm>
        </ValidationObserver>
        <BTable class="mt-2" ref="activitiesTable" :items="economicActivities" :fields="activitiesCols">
          <template #cell(name)="data">
            <TextInputValidated v-if="data.item.modify" :vsModel.sync="data.item.name" class="p-0 m-0"></TextInputValidated>
            <span v-else> {{ data.item.name }} </span>
          </template>
          <template #cell(section)="data">
            <TextInputValidated v-if="data.item.modify" :vsModel.sync="data.item.section" class="p-0 m-0"></TextInputValidated>
            <span v-else> {{ data.item.section }} </span>
          </template>
          <template #cell(epigraph)="data">
            <TextInputValidated v-if="data.item.modify" :vsModel.sync="data.item.epigraph" class="p-0 m-0"></TextInputValidated>
            <span v-else> {{ data.item.epigraph }} </span>
          </template>
          <template #cell(actions)="data">

            <BDropdown v-if="!data.item.modify" variant="link" no-caret :right="$store.state.appConfig.isRTL"  >
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <BDropdownItem @click="data.item.modify=true; activitiesTable.refresh()">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{ $t('Edit') }}</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopupAxios(data.item.id, `economic-activities/${data.item.id}`)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{ $t('Delete') }}</span>
              </BDropdownItem>
            </BDropdown>

            <div v-else class="d-flex">
              <BButton variant="flat-success" class="btn-icon" @click="editEconomicActivity(data.item)">
                <FeatherIcon size="18" icon="CheckIcon" />
              </BButton>
              <BButton variant="flat-danger" class="btn-icon" @click="data.item.modify=false; activitiesTable.refresh()">
                <FeatherIcon size="18" icon="XIcon" />
              </BButton>
            </div>

          </template>
        </BTable>
      </BCard>

      <BCard>
        <BRow class="mb-2">
          <BCol class="d-flex justify-content-between align-items-center">
            <h2>Cuentas bancarias</h2>
          </BCol>
        </BRow>
        <ValidationObserver ref="bankAccountForm">
          <BForm>
            <BRow class="d-flex justify-content-between align-items-center">
              <BCol md="10">
                <BRow>
                  <TextInputValidated vsName="Name" vsMd="2" :vsModel.sync="bank_account.name" vsRequired vsRules="required" />
                  <TextInputValidated vsName="IBAN" vsMd="3" :vsModel.sync="bank_account.iban" vsRequired vsRules="required" />
                  <TextInputValidated vsName="SWIFT/BIC" vsMd="2" :vsModel.sync="bank_account.swift_bic"/>
                  <TextInputValidated vsName="Identificador de acreedor" vsMd="2" :vsModel.sync="bank_account.creditor_id"/>
                  <TextInputValidated vsName="Identificador de presentador" vsMd="3" :vsModel.sync="bank_account.presenter_id"/>
                </BRow>
  
              </BCol>
              <BCol cols="2" class="text-right">
                <BButton  variant="primary" @click="createBankAccount">Añadir</BButton>
              </BCol>
            </BRow>
          </BForm>

        </ValidationObserver>
        <BTable class="mt-2" ref="bankAccountsTable" :items="bankAccounts" :fields="bankAccountsCols">
          <template #cell(name)="data">
            <TextInputValidated v-if="data.item.modify" :vsModel.sync="data.item.name" class="p-0 m-0"></TextInputValidated>
            <span v-else> {{ data.item.name }} </span>
          </template>
          <template #cell(iban)="data">
            <TextInputValidated v-if="data.item.modify" :vsModel.sync="data.item.iban" class="p-0 m-0"></TextInputValidated>
            <span v-else> {{ data.item.iban }} </span>
          </template>
          <template #cell(swift_bic)="data">
            <TextInputValidated v-if="data.item.modify" :vsModel.sync="data.item.swift_bic" class="p-0 m-0"></TextInputValidated>
            <span v-else> {{ data.item.swift_bic }} </span>
          </template>
          <template #cell(creditor_id)="data">
            <TextInputValidated v-if="data.item.modify" :vsModel.sync="data.item.creditor_id" class="p-0 m-0"></TextInputValidated>
            <span v-else> {{ data.item.creditor_id }} </span>
          </template>
          <template #cell(presenter_id)="data">
            <TextInputValidated v-if="data.item.modify" :vsModel.sync="data.item.presenter_id" class="p-0 m-0"></TextInputValidated>
            <span v-else> {{ data.item.presenter_id }} </span>
          </template>



          <template #cell(actions)="data">
            <BDropdown v-if="!data.item.modify" variant="link" no-caret :right="$store.state.appConfig.isRTL" >
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <BDropdownItem @click="data.item.modify=true; bankAccountsTable.refresh()">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{ $t('Edit') }}</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopupAxios(data.item.id, `bank-accounts/${data.item.id}`)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{ $t('Delete') }}</span>
              </BDropdownItem>
            </BDropdown>

            <div v-else class="d-flex">
              <BButton variant="flat-success" class="btn-icon" @click="editBankAccount(data.item)">
                <FeatherIcon size="18" icon="CheckIcon" />
              </BButton>
              <BButton variant="flat-danger" class="btn-icon" @click="data.item.modify=false; bankAccountsTable.refresh()">
                <FeatherIcon size="18" icon="XIcon" />
              </BButton>

            </div>

          </template>
        </BTable>
      </BCard>

    
      <BCard>
        <BRow class="mb-2">
          <BCol class="d-flex justify-content-between align-items-center">
            <h2>Impuestos</h2>
            <BButton v-b-toogle.taxSidebar variant="primary">Nuevo impuesto</BButton>
          </BCol>
        </BRow>
        <BTable ref="taxTable" :items="taxes" :fields="taxesCols">
          <template #cell(value)="data">
            <span>{{ data.item.value }} %</span>
          </template>
          <template #cell(equivalence)="data">
            <span>{{ data.item.equivalence }} %</span>
          </template>
          <template #cell(actions)="data">
            <BButton variant="flat-danger" class="btn-icon" @click="deletePopupAxios(data.item.id, `taxes/${data.item.id}`)">
              <FeatherIcon size="18" icon="TrashIcon" />
            </BButton>
          </template>
        </BTable>
      </BCard>
    </BForm>
    
    <!-- Sidebar -->
    <BSidebar ref="taxSidebar" id="taxSidebar" shadow bg-variant="white" backdrop right>
      <BRow>
        <BCol class="m-2">
          <BForm @submit.prevent="onCreateTax">
            <TextInputValidated vsName="Nombre" :vsModel.sync="taxAdd.name" vsLabel="name" vsRequired vsRules="required" class="p-0" />
            <NumberInputValidated vsName="Importe" :vsModel.sync="taxAdd.value" vsLabel="value" vsRequired vsRules="required" class="p-0" />
            <NumberInputValidated vsName="Recargo de equivalencia" :vsModel.sync="taxAdd.equivalence" vsLabel="equivalence" vsRequired vsRules="required" class="p-0" />
            <BButton type="submit" variant="primary">Crear impuesto</BButton>
          </BForm>
        </BCol>
      </BRow>
    </BSidebar>

  </div>
</template>

<script>
  import { BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BFormRadioGroup, BTable, BSidebar, VBToggle, BFormFile, BInputGroup, BFormRadio, BDropdown, BDropdownItem, BCardText} from 'bootstrap-vue'
  import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
  import { inject, ref } from '@vue/composition-api'
  import { getCountries, getProvinces, uploadCert } from '@/composables/settingsService'
  import { getTaxes, addTax } from '@/composables/taxService'
  import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import TextareaValidated from '@/components/forms/TextareaValidated.vue'
  import CheckboxValidated from '@/components/forms/CheckboxValidated.vue'
  import VSelectValidated from '@/components/forms/vSelectValidated.vue'
  import Ripple from 'vue-ripple-directive'
  import popups from '@/hooks/popups'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import axios from '@axios'
  import { addSerie, updateSerie } from '@/composables/serieService'
  import ViewData from '@/components/ViewData.vue'
  import ability from '@/libs/acl/ability'
  import { addEconomicActivity, getEconomicActivities, updateEconomicActivity } from '@/composables/economicActivityService'
  import { addBankAccount, getBankAccounts, updateBankAccount } from '@/composables/bankAccountService'

  export default {
    components: { BRow, BCol, BCard, BFormGroup, BFormInput, BFormRadioGroup, BForm, BButton, TextInputValidated, NumberInputValidated, CheckboxValidated, VSelectValidated, BTable, BSidebar, BFormFile, ValidationProvider, ValidationObserver, BInputGroup, TextareaValidated, BFormRadio, ViewData, BDropdown, BDropdownItem, BCardActions, BCardText},
    directives: { Ripple, 'b-toogle': VBToggle },
    setup(){
      const { deletePopupAxios ,errorToast, successToast } = popups()
      const taxes = ref([])
      const taxAdd = ref({})
      const taxTable = ref(null)
      const activitiesTable = ref(null)
      const bankAccountsTable = ref(null)
      const documentsTable = ref(0)
      const taxSidebar = ref(null)
      const economicActivities = ref([])
      const bankAccounts = ref([])
      const bankAccountForm = ref(null)
      const activityForm = ref(null)
      const serieForm = ref(null)

      const settings = inject('settings')
      const taxesCols = [
        { key: 'name', 'label': 'Nombre' },
        { key: 'value', 'label': 'Importe' },
        { key: 'equivalence', 'label': 'Recargo de equivalencia' },
        { key: 'actions', label: 'Acciones' }
      ]

      const activitiesCols = [
        { key: 'name', label: 'Nombre' },
        { key: 'section', label: 'Sección' },
        { key: 'epigraph', label: 'Epígrafe' },
        { key: 'actions', label: 'Acciones' }
      ]

      const bankAccountsCols = [
        { key: 'name', label: 'Nombre' },
        { key: 'iban', label: 'IBAN' },
        { key: 'swift_bic', label: 'SWIFT/BIC' },
        { key: 'creditor_id', label: 'Identificador de acreedor' },
        { key: 'presenter_id', label: 'ID de presentador' },
        { key: 'actions', label: 'Acciones' }
      ]

      const seriesCols = [
        { key: 'name', label: 'Nombre' },
        { key: 'identifier', label: 'Identificador' },
        { key: 'economic_activity', label: 'Actividad económica' },
        { key: 'sequence', label: 'Secuencia' },
        { key: 'actions', label: 'Acciones' }
      ]


      const serie = ref({
        name: null, 
        billing_document_id: null,
        identifier: null,
        is_default: false
      })

      const economic_activity = ref({
        name:null,
        section:null,
        epigraph:null
      })

      const bank_account = ref({
        name:null,
        iban:null,
        swift_bic:null,
        creditor_id:null,
        presenter_id:null,
      })


      const billingDocuments=ref([])


      const fetchEconomicActivities = async function () { economicActivities.value = (await getEconomicActivities()).data.economic_activities; return economicActivities.value}
      const fetchBankAccounts = async function () { bankAccounts.value = (await getBankAccounts()).data.bank_accounts}

      const fetchTaxes = async function() { taxes.value = await getTaxes() }
      
      fetchTaxes()
      fetchEconomicActivities()
      fetchBankAccounts()
      


      const refetchData = function() {
        fetchEconomicActivities()
        taxTable.value.refresh()
        activitiesTable.value.refresh()
        documentsTable.value++
        fetchBillingDocuments()
      }

      const createSerie = async function () {

        serieForm.value.validate().then(async success => {
          if(success){
            let response = await addSerie(serie.value)
            if (response.data.success) {
              successToast("Serie añadida correctamente")
              fetchBillingDocuments()

              serie.value = {
                name: null, 
                billing_document_id: null,
                economic_activity_id: null,
                identifier: null,
                is_default: false
              }

            } else {
              errorToast("Error añadiendo serie")
            }
          }
        })
      }

      const createEconomicActivity = async function () {

        
        activityForm.value.validate().then(async success => {
          if(success){
            if (economic_activity.value.section!=1 && economic_activity.value.section!= 2 && economic_activity.value.section!=3) {
              errorToast("La sección debe ser 1, 2 o 3.")
              return 
            }
            let response = await addEconomicActivity(economic_activity.value)
            fetchEconomicActivities()
            activitiesTable.value.refresh()
            if (response.data.success) {
              successToast("Actividad económica añadida correctamente")
              economic_activity.value = {
                name:null,
                section:null,
                epigraph:null
              }

            } else {
              errorToast("Error añadiendo actividad económica")
            }
          }
        })
      }

      const editEconomicActivity = async function (economicActivity) {
        if (economicActivity.name=='' || economicActivity.section=='' || economicActivity.epigraph=='') {
          errorToast("Faltan datos.")
          return 
        }
        if (economicActivity.section!=1 && economicActivity.section!= 2 && economicActivity.section!=3) {
          errorToast("La sección debe ser 1, 2 o 3.")
          return 
        }

        let response = await updateEconomicActivity(economicActivity)
        if (response.data.success) {
          successToast("Actividad económica actualizada correctamente.")
          fetchEconomicActivities()
          activitiesTable.value.refresh()
        } else {
          errorToast("Error actualizando actividad económica")
        }
      }

      const editSerie = async function (serie) {
        if (serie.name=='' || serie.economic_activity_id=='') {
          errorToast("Faltan datos.")
          return 
        }
        let response = await updateSerie(serie)
        if (response.data.success) {
          successToast("Serie actualizada correctamente.")
          fetchBillingDocuments()
          activitiesTable.value.refresh()
        } else {
          errorToast("Error actualizando serie")
        }

      }


      const createBankAccount = async function () {
        if (bank_account.value.iban && !/^[A-Za-z]{2}\d{22}$/.test(bank_account.value.iban)) {
          errorToast("Formato IBAN incorrecto")
          return
        }

        bankAccountForm.value.validate().then(async success => {
                if(success){
                  let response = await addBankAccount(bank_account.value)
                  if (response.data.success) {
                    successToast("Cuenta bancaria añadida correctamente")
                    bank_account.value = {
                      name:null,
                      iban:null,
                      swift_bic:null,
                      creditor_id:null,
                      presenter_id:null,
                    }

                    fetchBankAccounts()
                  } else {
                    errorToast("Error añadiendo cuenta bancarias")
                  }
                }
            })


      }

      const editBankAccount = async function (bankAccount) {
        if (bankAccount.iban && !/^[A-Za-z]{2}\d{22}$/.test(bankAccount.iban)) {
          errorToast("Formato IBAN incorrecto")
          return
        }

        if (bankAccount.name=='' || bankAccount.iban=='') {
          errorToast("Faltan datos")
          return
        }

        let response = await updateBankAccount(bankAccount)
        if (response.data.success) {
          successToast("Cuenta bancaria actualizada correctamente.")
          fetchBankAccounts()
          bankAccountsTable.value.refresh()
        } else {
          errorToast("Error actualizando cuenta bancaria")
        }
      }


      /**
       * Crear nuevo impuesto
       * @param {FormData} val 
       */
      const onCreateTax = async function() {
        let res = await addTax(taxAdd.value);
        if (res.success) {
          successToast('El impuesto ha sido creado correctamente')
        } else {
          errorToast('No ha sido posible crear el impuesto')
        }
        fetchTaxes()
        refetchData()
        taxSidebar.value.hide()
      }


      const fetchBillingDocuments = () => {
        axios.get('/billing-documents')
        .then((response)=> {
          billingDocuments.value=response.data
        })
        .catch((error)=> {

        })
      }

      fetchBillingDocuments()

      return {
        taxSidebar,
        taxesCols,
        taxTable,
        settings,
        economicActivities,
        taxAdd,
        taxes,
        billingDocuments,

        deletePopupAxios,
        onCreateTax,
        createSerie,
        createEconomicActivity,
        serie,
        ability,
        economic_activity,
        activitiesCols,
        seriesCols,
        activitiesTable,
        bank_account,
        bankAccountsTable,
        bankAccountsCols,
        bankAccounts,
        createBankAccount,
        fetchEconomicActivities,
        editEconomicActivity,
        editBankAccount,
        documentsTable,
        editSerie,
        bankAccountForm,
        activityForm,
        serieForm,
        refetchData
      }
    },
  }
</script>
